import React from "react";
import s from "./Label.module.scss";
import TextMAS from "components/TextMAS/TextMAS";

const Label = ({ label, mandatory }) => {
  // return <div className={s.inputLabel}>{label}</div>;
  return (
    <div className={s.inputLabel}>
      <TextMAS fontSize={"small"}>{label}</TextMAS>
      {mandatory && (
        <TextMAS fontSize="small" color="#db0d26">
          &nbsp;*
        </TextMAS>
      )}
    </div>
  );
};

export default React.memo(Label);
